/* Spare Parts Holland shipping reference-rate display.
   EUR values in the Liquid snippets are the source; checkout rates remain unchanged.
   ECB reference FX via Frankfurter; local cache (not a Shopify market/checkout rate). */
(function () {
  'use strict';
  if (window.__sphShippingFxInitialized) return;
  window.__sphShippingFxInitialized = true;
  var RATE_URL = 'https://api.frankfurter.dev/v2/providers/ecb/rate/eur/usd';
  var STORAGE_KEY = 'sph_shipping_ecb_eur_usd_v1';
  var CACHE_MS = 24 * 60 * 60 * 1000;
  var MAX_RATE_AGE_MS = 8 * 24 * 60 * 60 * 1000;
  var LB_PER_KG = 2.204622621848776;
  var promise = null;

  function safeLoad() {
    try {
      var data = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || 'null');
      return isValid(data) ? data : null;
    } catch (e) { return null; }
  }
  function isValid(data) {
    if (!data || !(data.rate > 0.5 && data.rate < 3) ||
        !/^\d{4}-\d{2}-\d{2}$/.test(data.date || '')) return false;
    var age = Date.now() - Date.parse(data.date + 'T00:00:00Z');
    return isFinite(age) && age > -24 * 3600000 && age < MAX_RATE_AGE_MS;
  }
  function getRate() {
    if (promise) return promise;
    var cached = safeLoad();
    if (cached && Date.now() - cached.savedAt < CACHE_MS && Date.now() >= cached.savedAt) {
      promise = Promise.resolve(cached);
      return promise;
    }
    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 8000) : null;
    promise = fetch(RATE_URL, {
      mode: 'cors', cache: 'no-store',
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) throw new Error('FX response');
      return response.json();
    }).then(function (data) {
      var value = { rate: Number(data.rate), date: data.date, savedAt: Date.now() };
      if (!isValid(value) || data.base !== 'EUR' || data.quote !== 'USD') {
        throw new Error('Invalid FX reference rate');
      }
      try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(value)); } catch (e) {}
      return value;
    }).catch(function () { return cached; }).finally(function () {
      if (timeout) window.clearTimeout(timeout);
    });
    return promise;
  }
  function renderRoot(root, data) {
    if (!data || !isValid(data) || !root || !root.isConnected) return;
    var us = root.getAttribute('data-sph-fx-country') === 'US';
    var locale = root.getAttribute('data-sph-fx-locale') || 'en';
    var format;
    try { format = new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' }); }
    catch (e) { format = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }); }
    root.querySelectorAll('[data-sph-fx-eur]').forEach(function (cell) {
      if (cell.getAttribute('data-sph-fx-done') === data.date + ':' + data.rate) return;
      var base = Number(cell.getAttribute('data-sph-fx-eur'));
      var byKg = cell.getAttribute('data-sph-fx-per-kg') === '1';
      if (!isFinite(base) || base < 0) return;
      var amount = base * data.rate / (us && byKg ? LB_PER_KG : 1);
      var unit = byKg ? (us ? ' / lb' : ' / kg') : '';
      var quote = cell.querySelector('.sph-shipping-fx-quote');
      if (!quote) return;
      var qualifier = '';
      if (!byKg) {
        var original = cell.querySelector('.sph-shipping-fx-original');
        if (original) {
          var originalLabel = (original.textContent || '').replace(/\s+/g, ' ').trim();
          qualifier = originalLabel.replace(/^€\s*[0-9.,]+\s*/, '');
        }
      }
      quote.textContent = format.format(amount) + unit + (qualifier ? ' ' + qualifier : '');
      quote.hidden = false;
      cell.classList.add('sph-shipping-fx-ready');
      cell.setAttribute('data-sph-fx-done', data.date + ':' + data.rate);
    });
    root.querySelectorAll('[data-sph-shipping-fx-source]').forEach(function (el) {
      el.textContent = 'ECB EUR/USD ' + data.date + ': 1 EUR \u2248 ' +
        Number(data.rate).toFixed(4) + ' USD';
      el.hidden = false;
    });
  }
  function apply() {
    var roots = document.querySelectorAll('.sph-shipping-info[data-sph-fx-currency="USD"]');
    if (!roots.length) return;
    getRate().then(function (value) {
      roots.forEach(function (root) { renderRoot(root, value); });
    }).catch(function () {});
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', apply, { once: true });
  } else { apply(); }
  document.addEventListener('shopify:section:load', apply);
})();